<template>
        <modal
            name="mass-add-work-days"
            class="modal--translation"
            v-cloak height="auto"
            :scrollable="true"
            :adaptive="true"
            :pivot-y="0.25"
            @before-open="beforeOpen"
        >
            <h5 class="modal-title" id="exampleModalLongTitle">{{ trans.massForm.title }}</h5>

            <button @click="closeModal()" type="button" class="close close-modal">
                <i class="fal fa-fw fa-times"></i>
            </button>

            <form class="mb-3">
                <div class="form-row">
                    <div class="form-group col-sm-6">
                        <label>{{ trans.massForm.from }}:</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
                            </div>
                            <datetime
                                v-model="from"
                                :config="datePickerConfig"
                                v-validate="'date_format:mm:ss'"
                                data-vv-as="Od"
                                class="flatpickr"
                            />
                        </div>
                    </div>
                    <div class="form-group col-sm-6">
                        <label>{{ trans.massForm.to }}:</label>
                        <div class="input-group">
                            <datetime
                                v-model="to"
                                :config="datePickerConfig"
                                v-validate="'date_format:mm:ss'"
                                data-vv-as="Do"
                                class="flatpickr"
                            />
                            <div class="input-group-append">
                                <span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <work-day-embed-form
                ref="workDayEmbedForm"
                :work-interval-types="workIntervalTypes"
                :default-interval="defaultInterval"
                :default-form-data="defaultFormData"
                :daily-working-fund="dailyWorkingFund"
                :trans="trans"
            />

            <b-alert
                v-if="intervalIsOverlaid && !isDiffMore"
                show variant="danger"
                class="col-12 d-flex align-items-center mt-3"
            >
                <i class="fal fa-exclamation-circle fa-2x mr-2"></i>
                <strong>
                    {{ trans.form.overlay_intervals }}
                </strong>
            </b-alert>

            <div class="text-center" style="margin-top: 30px;">
                <button
                    @click="submitForm()"
                    type="submit"
                    class="btn btn-primary"
                    :disabled='loading'
                >
                    <strong>{{ trans.saveBtn }}</strong>
                </button>

                <!-- <button
                    @click="closeModal()"
                    class="btn btn-secondary"
                    style="margin-top: 10px;"
                    type="button"
                >
                    Zavrieť
                </button> -->
            </div>
        </modal>
</template>

<script>
import {cloneDeep} from 'lodash';
import {Slovak as DatePickerLocaleSk} from "flatpickr/dist/l10n/sk.js";
import {Czech as DatePickerLocaleCs} from "flatpickr/dist/l10n/cs.js";

const userLanguage = document.documentElement.lang;

    export default {
        name: 'mass-work-days-modal-form',
        data: function() {
            return {
                loading: false,
                from: moment().startOf('month').format('YYYY-MM-DD'),
                to: moment().endOf('month').format('YYYY-MM-DD'),
                datePickerConfig: {
                    dateFormat: 'Y-m-d 00:00:00',
                    altInput: true,
                    altFormat: 'd.m.Y',
                    locale: this.getDatePickerLocale(userLanguage),
                    enable: [
                        {
                            from: moment().startOf('month').format('YYYY-MM-DD'),
                            to: moment().endOf('month').format('YYYY-MM-DD')
                        }
                    ]
                },
                momentSelectedMonth: null,
                defaultInterval: {
                    work_interval_type: 'work',
                    compensation_holiday: null,
                    from: moment().hours(8).minutes(0).seconds(0).format('kk:mm'),
                    to: moment().hours(12).minutes(0).seconds(0).format('kk:mm')
                },
                intervalIsOverlaid: false,
                isDiffMore: false,
                defaultFormData: {}
            }
        },

        props: {
            'baseUrl': {
                type: String
            },
            'workIntervalTypes': {
                type: Array
            },
            'selectedMonth': {
                type: String
            },
            'trans': {
                type: Object
            },
            'dailyWorkingFund': {
                type: Number,
                required: false,
                default: () => {
                    return 7;
                }
            }
        },

        created() {
            this.momentSelectedMonth = moment(this.selectedMonth, 'YYYY-MM');

            this.from = this.momentSelectedMonth.startOf('month').format('YYYY-MM-DD');
            this.to = this.momentSelectedMonth.endOf('month').format('YYYY-MM-DD');

            this.datePickerConfig.enable = [
                {
                    from: this.momentSelectedMonth.startOf('month').format('YYYY-MM-DD'),
                    to:  this.momentSelectedMonth.endOf('month').format('YYYY-MM-DD')
                }
            ];
        },

        methods: {
            beforeOpen (event) {

                const form = {
                    intervals: cloneDeep( [this.defaultInterval] )
                };

                this.defaultFormData = form;
            },

            submitForm() {
                const _this = this;
                const data = this.$refs.workDayEmbedForm.getData();

                data.from = this.from;
                data.to   = this.to;

                this.loading = true;
                this.$emit('setmassbuttonloading', true);

                if( this.$refs.workDayEmbedForm.validateIntervals() ) this.intervalIsOverlaid = true;
                else this.intervalIsOverlaid = false;

                if( this.$refs.workDayEmbedForm.validateWorkedHolidays() ) this.isDiffMore = true;
                else this.isDiffMore = false;

                if( !this.intervalIsOverlaid && !this.isDiffMore ) {
                    axios.post(this.baseUrl, data).then(function (response) {
                        return _this.onSuccess(response);
                    }).catch(function (errors) {
                        return _this.onFail(errors);
                    });
                }
            },

            onSuccess(response) {
                this.closeModal();

                this.$emit('refreshattendance');
                this.$emit('refreshcalendar');
                this.$emit('refreshbalances');
                this.$emit('setmassbuttonloading', false);
                
                this.loading = false;

                if(response.data.type == 'warning') {
                  this.$notify({ type: 'warning', title: 'Upozornenie', text: response.data.message ? response.data.message : 'Some data not created.' });
                } else {
                  this.$notify({ type: 'success', title: 'Success!', text: response.data.message ? response.data.message : 'Item successfully created.' });
                }
            },

            onFail(errors) {
                this.closeModal();

                this.$emit('refreshattendance');
                this.$emit('refreshcalendar');
                this.$emit('refreshbalances');
                this.$emit('setmassbuttonloading', false);
                
                this.loading = false;

                this.$notify({ type: 'error', title: 'Error!', text: 'An error has occured.' });
            },

            closeModal() {
                this.$modal.hide('mass-add-work-days');
            },

            getDatePickerLocale(langCode) {
                if(langCode == 'sk') return DatePickerLocaleSk;

                if(langCode == 'cs') return DatePickerLocaleCs;

                return null;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/modals/MassWorkDaysModalForm.vue